"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_STATE = void 0;
exports["default"] = addressSearchReducer;
var _get = _interopRequireDefault(require("lodash/get"));
var _addressSearch = require("../../../form/configs/addressSearch");
var _addressSearchActionConstants = require("../../actions/addressSearch/addressSearchActionConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var INITIAL_STATE = exports.INITIAL_STATE = {
  apiKey: '',
  loqateAddressSearchCallActive: false,
  previousSearchTerm: undefined,
  results: [],
  showBackToResultsButton: false,
  overmatchTimeoutErrorOccured: false,
  networkTimeoutOccured: false,
  showSelectBelowOnEnterMessage: undefined
};
function addressSearchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var formId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _addressSearch.ADDRESS_SEARCH_FORM_ID;
  var addressSearchInputId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var prefix = addressSearchInputId ? "".concat(addressSearchInputId, "_") : '';
  switch (action.type) {
    case "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".LOADING"):
      return _objectSpread(_objectSpread({}, state), {}, {
        loqateAddressSearchCallActive: true,
        networkTimeoutOccured: false,
        overmatchTimeoutErrorOccured: false
      });
    case "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".NETWORK_TIMEOUT"):
    case "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".NETWORK_TIMEOUT"):
      return _objectSpread(_objectSpread({}, state), {}, {
        loqateAddressSearchCallActive: false,
        networkTimeoutOccured: true
      });
    case "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".TIMEOUT_ERROR"):
      return _objectSpread(_objectSpread({}, state), {}, {
        loqateAddressSearchCallActive: false,
        overmatchTimeoutErrorOccured: true,
        networkTimeoutOccured: false
      });
    case "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".FAILED"):
      return _objectSpread(_objectSpread({}, state), {}, {
        overmatchTimeoutErrorOccured: false,
        networkTimeoutOccured: false
      });
    case "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SEARCH, ".SUCCESS"):
      return _objectSpread(_objectSpread({}, state), {}, {
        loqateAddressSearchCallActive: false,
        results: action.items,
        previousSearchTerm: action.isContainer ? state.previousSearchTerm : action.previousSearchTerm,
        showBackToResultsButton: action.isContainer,
        overmatchTimeoutErrorOccured: false,
        networkTimeoutOccured: false
      });
    case "".concat(prefix).concat(_addressSearchActionConstants.LOQATE_ADDRESS_SELECT, ".SUCCESS"):
      return _objectSpread(_objectSpread({}, state), {}, {
        results: []
      });
    case _addressSearchActionConstants.SET_LOQATE_API_KEY:
      return _objectSpread(_objectSpread({}, state), {}, {
        apiKey: action.apiKey,
        loqateAddressSearchCallActive: false,
        overmatchTimeoutErrorOccured: false
      });
    case '@@redux-form/SET_SUBMIT_SUCCEEDED':
      if ((0, _get["default"])(action, 'meta.form') === formId) {
        var minimumCharactersEntered = (0, _get["default"])(state, 'inputValue', '').length >= 3;
        return _objectSpread(_objectSpread({}, state), {}, {
          showSelectBelowOnEnterMessage: {
            title: minimumCharactersEntered ? 'Please select an address from the options below' : 'Please keep typing to find an address',
            refreshes: (0, _get["default"])(state, 'showSelectBelowOnEnterMessage.refreshes', 0) + 1
          }
        });
      }
      return state;
    case '@@redux-form/DESTROY':
      if ((0, _get["default"])(action, 'meta.form[0]') === formId) {
        return _objectSpread(_objectSpread({}, state), {}, {
          showSelectBelowOnEnterMessage: undefined
        });
      }
      return state;
    case '@@redux-form/CHANGE':
      if ((0, _get["default"])(action, 'meta.form') === formId) {
        // preserve the form input value so it can be used in the SET_SUBMIT_SUCCEEDED case above
        var inputValue = (0, _get["default"])(action, 'payload');
        if (inputValue === '') {
          return _objectSpread(_objectSpread({}, state), {}, {
            showSelectBelowOnEnterMessage: undefined,
            inputValue: inputValue
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          inputValue: inputValue
        });
      }
      return state;
    default:
      return state;
  }
}